module.exports = __webpack_public_path__ + "static/media/kushner-inauguration.8c4f2900.jpg";